import { render, staticRenderFns } from "./BusquedaGeneral.vue?vue&type=template&id=09bc4d2d&"
import script from "./BusquedaGeneral.vue?vue&type=script&lang=js&"
export * from "./BusquedaGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports